module.exports = __webpack_public_path__ + "static/media/line.9d94a95e.svg";